import { render, staticRenderFns } from "./LetterTemplates.vue?vue&type=template&id=23a490dd&scoped=true&lang=pug&"
import script from "./LetterTemplates.vue?vue&type=script&lang=ts&"
export * from "./LetterTemplates.vue?vue&type=script&lang=ts&"
import style0 from "./LetterTemplates.vue?vue&type=style&index=0&id=23a490dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a490dd",
  null
  
)

export default component.exports